import React, { Component } from 'react'

export default class StartGuide extends Component {
  render() {
    return (
        <div className="cover_container">
        <img src='https://i.ibb.co/gMXwTGG/slice1-3x.png' alt="slice1-3x" className="cover_logo" border="0"/>
      <div className="cover_title">
        <p className="text_beginner">Beginner's</p>
		<p className="text_guide">Guide</p>
      </div>
     </div> )
           }
    }



// WEBPACK FOOTER //
// ./src/components/StartGuide.js